import { render, staticRenderFns } from "./table.saleorders.vue?vue&type=template&id=32504063"
import script from "./table.saleorders.vue?vue&type=script&lang=js"
export * from "./table.saleorders.vue?vue&type=script&lang=js"
import style0 from "./table.saleorders.vue?vue&type=style&index=0&id=32504063&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports